<template>
  <div>
    <ModalFile
        v-if="selectedImage !== null"
        v-show="isModalVisible"
        :selected-image="value[selectedImage]"
        @close="closeModal"
        @validate="validateModal"
    />
    <div class="form-field form-file multiple" :rel="uniqueId">
      <div class="form-label" v-if="label">
        <label>{{ label }}</label>
      </div>
      <div class="form-input">
        <div class="form-input-wrapper">

          <draggable
              v-model="value"
              @start="drag = true"
              @end="updateValue"
              :options="{ handle: '.drag' }"
              class="listing"
          >
            <div
                v-for="(item, index) in value"
                :key="item.id || index"
                class="item drag"
                :title="item.original_filename"
            >
              <div class="image">
                <img :src="item.url" />
                <div class="bt-actions">
                  <button
                      class="bt-edit"
                      v-if="item.url"
                      @click="selectImage(index)"
                  >
                    <icon name="edit-02" />
                  </button>
                  <button
                      class="bt-remove"
                      v-if="item.url"
                      @click="remove(index)"
                  >
                    <icon name="trash-01" />
                  </button>
                </div>
              </div>
              <div class="name" v-if="item.size && item.size.width">
                <input
                    type="text"
                    :value="item.url"
                    :id="'copy_' + index"
                    style="position: absolute;"
                    readonly
                />
                <span>{{ item.size.width }} x {{ item.size.height }} px</span>
                <i
                    class="icon icon-icon_tags"
                    @click="copyToClipboard(item.url)"
                ></i>
              </div>
            </div>
          </draggable>

          <div
              class="form-file-upload"
              :class="{ 'is-dragging': isDragging }"
              @dragover.prevent="onDragOver"
              @dragleave.prevent="onDragLeave"
              @drop.prevent="onDrop"
              @click="browseFiles"
          >
            <input
                class="input"
                ref="fileInput"
                type="file"
                :id="uniqueId"
                @change="upload"
                multiple
                style="display: none;"
            />
            <icon name="image-03"/>
            <span>Glissez-déposez vos fichiers ici, ou <u>cliquez pour parcourir</u></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalFile from "./ModalFile.vue";
import { Api } from "../../Api.js";

export default {
  name: "Upload",
  components: { ModalFile },
  props: {
    value: {
      type: Array,
      default: function () {
        return [];
      }
    },
    width: {
      type: String,
      default: "auto"
    },
    label: String
  },
  data: function () {
    return {
      selectedImage: null,
      isModalVisible: false,
      drag: false,
      isDragging: false,
      uniqueId: "file-upload-" + Math.random().toString(36).substr(2, 9),
      sizeW: this.width ? this.width + "px" : "auto"
    };
  },
  methods: {
    browseFiles: function () {
      this.$refs.fileInput.click(); // Déclenche le clic sur l'input file caché
    },
    onDragOver: function () {
      this.isDragging = true; // Indique que l'utilisateur a glissé des fichiers
    },
    onDragLeave: function () {
      this.isDragging = false; // Réinitialise lorsque les fichiers quittent la zone
    },
    onDrop: function (event) {
      this.isDragging = false; // Réinitialise la classe
      if (event.dataTransfer && event.dataTransfer.files) {
        this.upload(event); // Transfère les fichiers à la méthode existante
      }
    },
    upload: function (event) {
      var files = event.target.files || event.dataTransfer.files;
      var data = new FormData();

      for (var i = 0; i < files.length; i++) {
        data.append("files[]", files[i]);
      }

      var self = this;
      Api()
          .post("media", data)
          .then(function (response) {
            var newItems = response.data.filter(function (item) {
              return !self.value.some(function (existingItem) {
                return existingItem.id === item.id;
              });
            });

            // Ajout des nouvelles images
            self.value = self.value.concat(newItems);
            self.updateValue();
          });
    },
    remove: function (index) {
      if (confirm("Etes-vous certain de vouloir supprimer ce fichier ?")) {
        this.value.splice(index, 1);
        this.updateValue();
      }
    },
    copyToClipboard: function (text) {
      var tempInput = document.createElement("input");
      tempInput.value = text;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      alert("Texte copié dans le presse-papier !");
    },
    selectImage: function (index) {
      this.selectedImage = index;
      this.openModal();
    },
    openModal: function () {
      this.isModalVisible = true;
    },
    closeModal: function () {
      this.isModalVisible = false;
    },
    validateModal(image) {
      this.isModalVisible = false;
      this.value[this.selectedImage] = image;
    },
    updateValue: function () {
      this.$emit("input", this.value); // Synchroniser après drag & drop
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/form/Gallery.vue